const INTERACTIVE_SELECTOR = "button, a";

/**
 * @export
 * @function createInteractiveElArray 要素内にあるフォーカス可能な要素を取得
 * @param {HTMLElement} element
 * @returns {(HTMLButtonElement | HTMLAnchorElement)[]}
 */
export function createInteractiveElArray(element: HTMLElement): (HTMLButtonElement | HTMLAnchorElement)[] {
  return Array.from(element.querySelectorAll<HTMLButtonElement | HTMLAnchorElement>(INTERACTIVE_SELECTOR));
}

/**
 * 要素の先頭と末尾どちらかにフォーカスを与えます。
 * @param parentElement 対象の親要素
 * @param isFirstFocus 先頭と末尾のどちらにフォーカスを与えるか指定します。
 */
export function focusToButton(parentElement: HTMLElement, isFirstFocus = true): void {
  if (!parentElement) {
    throw new Error("要素が見つかりませんでした");
  }

  const focusableArray: (HTMLButtonElement | HTMLAnchorElement)[] = createInteractiveElArray(parentElement);

  if (focusableArray.length > 0) {
    focusableArray[isFirstFocus ? 0 : focusableArray.length - 1].focus();
  }
  focusableArray[0].focus();
}

/**
 * @function handleFocus キーボードフォーカスを制御するイベント
 * @param e
 * @param parentElement 対象の親要素
 * @param onClose モーダルを閉じる処理
 */
export function handleFocus(e: KeyboardEvent, parentElement: HTMLElement, onClose: () => void) {
  if (!parentElement) {
    return;
  }
  switch (e.code) {
    case "Enter":
    case "Space":
      break;
    case "Escape":
      onClose();
      break;
    case "Tab": {
      // モーダル画面内にフォーカスが当たっているか検証
      const interactiveElArray = createInteractiveElArray(parentElement);
      const focusIndex = interactiveElArray.findIndex((el) => el === document.activeElement);

      if (interactiveElArray.length === 1) {
        console.log("フォーカス可能な要素が1つしかない場合、その要素のみフォーカス");
        e.preventDefault();
        e.stopImmediatePropagation();
        focusToButton(parentElement, true);
        break;
      }

      if (focusIndex === 0) {
        if (e.shiftKey) {
          console.log("モーダル画面以外にフォーカスが当たっていたらイベントを無効化");
          e.preventDefault();
          e.stopImmediatePropagation();

          focusToButton(parentElement, false);
        }
      } else if (focusIndex >= interactiveElArray.length - 1) {
        // 最後の要素にふれていたら1番目の要素にフォーカスをあてる
        if (!e.shiftKey) {
          console.log("最後の要素にふれていたら1番目の要素にフォーカスをあてる");
          e.preventDefault();
          e.stopImmediatePropagation();

          focusToButton(parentElement, true);
        }
      } else if (focusIndex === -1) {
        console.log("画面外の要素にフォーカスがあたっていたら1番目の要素にフォーカスをあてる");
        focusToButton(parentElement, true);
      }
      break;
    }
  }
}
